export default __webpack_public_path__ + "static/media/1-formatOriginal.d0ff2dd4.webp";